import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { engageLabCore } from '@jg/qiankun-micro-tool';
import { RouterView, useRouter, useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const currentOrg = engageLabCore.organization.takeImmediately();
const router = useRouter();
const route = useRoute();
if ((location.hash === '#/' || !location.hash) && currentOrg.id) {
  router.push({ name: 'overview', params: { id: currentOrg.id } });
} else if (!currentOrg.id) {
  router.push({ name: 'organization' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_unref(RouterView))
  ]))
}
}

})